import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Rankings from "../pages/rankings/page";
import CategoryPage from "../pages/category/page";
import ListingPage from "../pages/listing/ListingPage";
import MangaDetail from "../pages/manga/page";
import About from "../pages/about/page";
import FaqPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/rankings",
    element: <Rankings />,
  },
  {
    path: "/category/:id",
    element: <CategoryPage />,
  },
  {
    path: "/new",
    element: <ListingPage type="new" />,
  },
  {
    path: "/completed",
    element: <ListingPage type="completed" />,
  },
  {
    path: "/free",
    element: <ListingPage type="free" />,
  },
  {
    path: "/manga/:id",
    element: <MangaDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;